module.exports = __webpack_public_path__ + "6b5576ff19924bc3d3559f08ed05ecb8.pdf";